//-------------------------------------------------------------------------------------------------- Imports
import { Row, Card, Typography, Col, Input, Button } from "antd";
import { StyleSheet } from "../../StyleSheet";
import { useDispatch, useSelector } from "react-redux";
import { getGeneralData } from "../../stores/slices/generalDataSlice";
import { useCallback, useEffect, useState } from "react";
import { AppDispatch } from "../../stores/store";
import SubDefaultLayout from "../../components/SubDefaultLayout";
import InfoCardComponent from "../../components/InfoCardComponent";
import { referredValidateCode } from "../../methods/Methods";
import { AlertSliceInterface, clearAlert, setAlert, showAlert } from "../../stores/slices/alertSlice";
import Loading from "../../components/Loading";
const { Text } = Typography;

//-------------------------------------------------------------------------------------------------- View
const RegisterCode = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { selectedContract } = useSelector(getGeneralData);
    const [idCliente, setIdCliente] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [codeRegister, setCodeRegister] = useState("");
    const [hasChanges, setHasChanges] = useState(false);

    const handleChangeCode = (event: React.ChangeEvent<HTMLInputElement>) => {
        const limit = 6;
        const value = event.target.value.slice(0, limit);

        if (value.length <= limit) {
            setCodeRegister(value);
        }
    };

    const SendVerifyCode = async () => {
        if (idCliente) {
            let typeAlert = "";
            let messageAlert = "";
            setIsLoading(true);
            await referredValidateCode(codeRegister, idCliente)
                .then((response) => {
                    if (response.data.data[0].status) {
                        typeAlert = "SUCCESS";
                        messageAlert = response.data.data[0].mensaje;
                    } else {
                        typeAlert = "ERROR";
                        messageAlert = response.data.data[0].mensaje;
                    }
                    let dispatchAlert: AlertSliceInterface = {
                        show: true,
                        type: typeAlert as "INFO" | "SUCCESS" | "ERROR",
                        title: "¡Estimado Usuario!",
                        message: messageAlert,
                        onFinalize: () => handleDispatchAlertModal()
                    }
                    openAlertModal(dispatchAlert);
                    setIsLoading(false);
                })
                .catch(() => {
                    let dispatchAlert: AlertSliceInterface = {
                        show: true,
                        type: "ERROR",
                        title: "¡Estimado Usuario!",
                        message: "Hubo un error al procesar su solicitud. \nIntente más tarde.",
                        onFinalize: () => handleDispatchAlertModal()
                    }
                    openAlertModal(dispatchAlert);
                    setIsLoading(false);
                });
        }
    };

    const handleDispatchAlertModal = useCallback(() => {
        dispatch(showAlert(false));
        dispatch(clearAlert());
    }, [dispatch]);

    const openAlertModal = useCallback((option: AlertSliceInterface) => {
        dispatch(setAlert({
            show: option.show,
            type: option.type as "INFO" | "SUCCESS" | "ERROR",
            title: option.title,
            message: option.message,
            onFinalize: option.onFinalize
        }));
    }, [dispatch]);

    useEffect(() => {
        if (selectedContract !== null) {
            setIdCliente(
                selectedContract.sucursal +
                selectedContract.suscriptor
            );
        }
    }, [selectedContract]);

    useEffect(() => {
        if (codeRegister.length === 6) {
            setHasChanges(true);
        } else {
            setHasChanges(false);
        }
    }, [codeRegister]);
    
    return (
        <>
            {
                isLoading ?
                    <Loading />
                    :
                    <SubDefaultLayout title={"Registrar Código"} needReturn={true} navigateTo="/referral-system">
                        <div>
                            <InfoCardComponent title="¡Estimado Usuario!" description={"Registra tu código."} />
                        </div>
                        <Row style={styles.rowCardPrincipal}>
                            <Col xs={16} xl={14} style={{ paddingLeft: 10 }}>
                                <Card bodyStyle={{ justifyContent: 'center' }} style={{ ...styles.cardRoot, marginTop: 10 }}>
                                    <Row style={{ ...styles.rowButton, justifyContent: 'center' }}>
                                        <Col xl={8} xs={8}>
                                            <div style={{ marginTop: 15 }}>
                                                <Text style={styles.inputTitle}>Ingresa el código</Text>
                                                <Input
                                                    value={codeRegister}
                                                    style={styles.inputText}
                                                    onChange={handleChangeCode}
                                                    status={codeRegister === "" ? "error" : ""}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row justify="center" gutter={[18, 18]} style={{ marginTop: 20 }}>
                                        <Col>
                                            <div style={{ marginTop: 15 }}>
                                                <Button
                                                    style={!hasChanges ? styles.buttonDisabled : styles.buttonFinal}
                                                    onClick={() => SendVerifyCode()}
                                                    type="primary"
                                                    disabled={!hasChanges}
                                                >
                                                    Canjear Código
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </SubDefaultLayout>
            }
        </>
    );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    cardRoot: {
        backgroundColor: 'white',
        marginBottom: 15,
        boxShadow: "0px 0px 8px #00000029",
        borderRadius: 20
    },
    rowCardPrincipal: {
        marginTop: 25,
        display: 'flex',
        justifyContent: 'center',
    },
    inputText: {
        marginTop: 15,
        color: "#000000",
        borderColor: '#000000',
        fontSize: 12
    },
    rowButton: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    inputTitle: {
        color: "#0055c2",
        fontWeight: 600,
        fontSize: 12
    },
    buttonFinal: {
        backgroundColor: "#0055c2",
        borderRadius: 15,
        color: "white",
        boxShadow: "3px 3px 5px 0px rgba(0,0,0,0.10)",
        marginBottom: 10,
    },
    emptyFieldError: {
        fontSize: 11
    },
    buttonDisabled: {
        backgroundColor: "#787B7F",
        borderRadius: 15,
        color: "white",
        boxShadow: "3px 3px 5px 0px rgba(0,0,0,0.10)",
        marginBottom: 10,
    },
});

//-------------------------------------------------------------------------------------------------- Exports
export default RegisterCode;
